import { faClose } from '@fortawesome/pro-regular-svg-icons';
import { Drawer as AntdDrawer, Tooltip } from 'antd';
import { DrawerProps } from 'antd/lib/drawer';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { ButtonStyle, TextButtonStyle } from '../button/button';
import { FontAwesomeIcon } from '../icon/icon';

interface CloseIconProps {
  showTooltip: boolean;
}

const CloseIconWrapper = styled.div`
  ${ButtonStyle};
  ${TextButtonStyle};
  height: var(--height-base);
`;

export const CloseIcon: FC<React.PropsWithChildren<CloseIconProps>> = ({
  showTooltip,
}) => (
  <Tooltip
    placement="left"
    data-cy="close.icon"
    title={showTooltip && <FormattedMessage id="esc_to_close" />}
  >
    <CloseIconWrapper>
      <FontAwesomeIcon icon={faClose} data-cy="close.icon" />
    </CloseIconWrapper>
  </Tooltip>
);

export const Drawer = styled(AntdDrawer).attrs<DrawerProps>((props) => {
  const { keyboard = true } = props;

  return {
    closeIcon: <CloseIcon showTooltip={keyboard} data-cy="antd-drawer.close" />,
    mask: false,
    ...props,
  };
})`
  --drawer-spacing-around: var(--spacing-02);
  .ant-drawer-header-title {
    flex-direction: row-reverse;
  }
  .ant-drawer-header {
    padding: 0;
    font-size: 16px;
    line-height: 0;
    /* border-bottom: none; */
    /* position: absolute; */
    /* top: 0px;
    right: 0px; */
    /* z-index: var(--zindex-modal-lowest); */
    margin-right: 0px;
  }
  .ant-drawer-close {
    position: absolute;
    top: var(--drawer-spacing-around);
    right: var(--drawer-spacing-around);
    padding: var(--spacing-05) var(--spacing-06);
    margin-right: 0px;
    z-index: var(--zindex-elevated);
    & > span {
      display: flex;
      align-items: center;
    }
  }

  .ant-drawer-body {
    padding: 0;
    overflow: auto;
  }
  /* .ant-drawer-close {
    display: flex;
    padding: var(--spacing-05);
    & > span {
      display: flex;
      align-items: center;
    }
    &:hover {
      background-color: var(--black-with-opacity);
    }
  } */

  .ant-drawer-content-wrapper {
    width: 100%;
    box-shadow: none;
    padding: 0px;
    margin: var(--spacing-03);
    &:before {
      background-color: transparent;
      content: '';
      bottom: 0;
      left: -100vw;
      pointer-events: none;
      position: fixed;
      top: 0;
      transition: background-color ease-in-out var(--animation-duration-medium);
      width: 100vw;
    }
  }
  .ant-drawer-content {
    border-radius: var(--border-radius-small);
  }

  .ant-drawer-footer {
    align-items: center;
    display: flex;
    justify-content: flex-end;
    padding: var(--layout-02);

    > button + button {
      margin-left: var(--layout-01);
    }
  }
`;
